import template from './form.html';
import { FormActions } from 'core/services/form';
import { rest } from 'core/api';
import timbradosI18N from 'i18n/timbrados/es.json';
import commonI18N from 'i18n/common/es.json';
import { pad } from 'core/util';
import { formatErrorMessage } from 'core/util';

export let TimbradoFormComponent = {
  templateUrl: template,
  selector: 'timbradoForm',
  bindings: {
    view: '<',
    translations: '='
  },
  controller: FormController,
  controllerAs: 'vm'
};

export const translationKeys = Object.keys(timbradosI18N).concat(Object.keys(commonI18N));


FormController.$inject = ['$state', '$ngRedux', 'ngNotify', '$stateParams', 'Filter', '$scope', '$timeout', 'AuthorizationService'];

function FormController($state, $ngRedux, ngNotify, $stateParams, Filter, $scope, $timeout, AuthorizationService) {
  this.cancel = cancel.bind(this);
  this.doSubmit = doSubmit.bind(this);
  this.handleErrors = handleErrors.bind(this);
  this.mapStateToThis = mapStateToThis.bind(this);
  this.onChangeDate = onChangeDate.bind(this);
  this.renderSucursal = renderSucursal.bind(this);

  this.newDetalle = newDetalle.bind(this);
  this.deleteDetalle = deleteDetalle.bind(this);
  this.renderPuntoEmision = renderPuntoEmision.bind(this);
  this.renderTipoComprobante = renderTipoComprobante.bind(this);
  this.onSelectSucursal = onSelectSucursal.bind(this);

  this.establecerUltimaNumeracion = establecerUltimaNumeracion.bind(this);

  let unsubscribe;

  const activoFilter = Filter.path('activo').eq(true);
  const valoresFilter = Filter.path('tipo.codigo').eq('clase_timbrado')
    .or(Filter.path('tipo.codigo').eq('estado_activacion'))
    .or(Filter.path('tipo.codigo').eq('clase_tipo_comprobante'));

  this.$onDestroy = () => {
    this.form();
    unsubscribe();
  };

  this.$onInit = () => {
    unsubscribe = $ngRedux.connect(this.mapStateToThis, FormActions)(this);

    this.canModificarUltimaNumeracion = AuthorizationService.hasPermission('update_ultima_numeracion_timbrado');

    if ($stateParams.uid) {
      this.title = this.view ? this.translations['Ver timbrado'] : this.translations['Editar timbrado'];
      this.formEdit('timbrados', $stateParams.uid);
    } else {
      this.title = this.translations['Nuevo timbrado'];
      this.form();
    }
    $ngRedux.dispatch(rest.actions.sucursales.get());
    $ngRedux.dispatch(rest.actions.tiposComprobantes.get({ filter: JSON.stringify(activoFilter) }));
    $ngRedux.dispatch(rest.actions.valores.get({ filter: JSON.stringify(valoresFilter) }));
  };

  this.localModel = {
    hastaOptions: {},
    desdeOptions: {}
  };

  function onChangeDate() {
    if (this.model) {
      this.localModel.desdeOptions.maxDate = this.model.hasta;
      this.localModel.hastaOptions.minDate = this.model.desde;
    }
  }

  function mapStateToThis(state) {
    this.handleErrors(state);
    this.submitted = state.form.flags ? state.form.flags.submitted : false;
    this.model = state.form.model;

    if (!this.model.id && state.valores.data && state.valores.data.length > 0) {
      let estados = state.valores.data.filter(v => v.tipo.codigo === 'estado_activacion');
      let estadoActivo = estados.filter(v => v.value === 'Activo')[0];
      this.model.estado = estadoActivo;

      if (!this.model.detalles) {
        this.model.detalles = [];
      }
    }

    if (this.model && this.model.sucursal && !this.puntosEmision) {
      this.onSelectSucursal();
    }

    if (this.model && this.model.detalles) {
      this.model.detalles.forEach(detalle => {
        detalle.minNumeroFinal = detalle.numeroFinal || detalle.numeroInicial;
      });
    }

    this.onChangeDate();
    return {
      form: state.form,
      sucursales: state.sucursales.data,
      tiposComprobantes: state.tiposComprobantes.data,
      estados: state.valores.data.filter((v) => v.tipo.codigo === 'estado_activacion'),
      clasesTimbrado: state.valores.data.filter((v) => v.tipo.codigo === 'clase_timbrado'),
      clases: state.valores.data.filter(v => v.tipo.codigo === 'clase_tipo_comprobante')
    };
  }

  /**
   * Función que se encarga de mostrar mensajes de error en base al estado actual
   *
   * @param {object} state
   */
  function handleErrors(state) {
    if (state.form.notFound) {
      const msg = `${this.translations['No existe el elemento con ID']} ${$stateParams.uid}`;
      ngNotify.set(msg, 'warn');
      $timeout(() => $state.go('home.timbrados.list'));
      return;
    }

    if (state.form.error) {
      ngNotify.set(formatErrorMessage(state.form.error.message), { type: 'error', html: true });
    }

    if (state.form.created) {
      ngNotify.set(this.translations['Datos guardados correctamente'], 'success');
      $state.go('home.timbrados.list');
    }

    if (state.sucursales.error) {
      ngNotify.set(state.sucursales.error.message, 'error');
    }

    if (state.roles.error) {
      ngNotify.set(state.roles.error.message, 'error');
    }
  }


  /**
   * Cancela el formulario y retorna al listado
   */
  function cancel() {
    $state.go('home.timbrados.list');
  }

  function doSubmit() {
    console.log(this.model);
    if ($scope.timbradoForm.$invalid) {
      this.submitted = true;
      return;
    }
    let data = Object.assign({}, this.model);
    data.detalles.forEach(function(item) {
      if (!item.id) {
        establecerUltimaNumeracion(item);
      }
    });

    this.save('timbrados', data);
  }

  function renderSucursal(item) {
    return `<small><strong>(${pad(item.codigo, 3)})</strong></small> - ${item.nombre}`;
  }

  function newDetalle() {
    let detalle = {};
    let firstPunto = this.puntosEmision ? this.puntosEmision[0] : null;
    let firstComprobante = this.tiposComprobantes ? this.tiposComprobantes[0] : null;
    if (firstPunto) {
      detalle.puntoEmision = firstPunto;
    }

    if (firstComprobante) {
      detalle.tipoComprobante = firstComprobante;
    }
    detalle.numeroInicial = 1;
    //detalle.numeroFinal = 100;
    detalle.ultimaNumeracion = detalle.numeroInicial;

    this.model.detalles.push(detalle);
  }

  function deleteDetalle(detalle) {
    _.remove(this.model.detalles, detalle);
  }

  function establecerUltimaNumeracion(detalle) {
    detalle.ultimaNumeracion = detalle.numeroInicial;
  }

  function onSelectSucursal() {
    this.puntosEmision = this.model.sucursal.detalles;
  }


  function renderPuntoEmision(detalle) {
    let codigoDetalle = detalle.codigo ? detalle.codigo : 0;
    return `${pad(codigoDetalle, 3)}`;
  }

  function renderTipoComprobante(item) {
    return `${ item.nombre } <small><strong>(${item.clase.name })</strong></small>`;
  }

}



// WEBPACK FOOTER //
// ./src/components/timbrados/form/form.component.js